/**
 * THIS FILE IS GENERATED AUTOMATICALLY.
 * DO NOT EDIT.
 *
 * You are probably looking on adding startup/initialization code.
 * Use "quasar new boot <name>" and add it there.
 * One boot file per concern. Then reference the file(s) in quasar.conf.js > boot:
 * boot: ['file', ...] // do not add ".js" extension to it.
 *
 * Boot files are your "main.js"
 **/

import lang from 'quasar/lang/fr'


import Vue from 'vue'

import {Quasar,Notify,Loading,LocalStorage,Screen,AppFullscreen,Cookies} from 'quasar'


Vue.use(Quasar, { config: {"notify":{"position":"top","color":"positive"},"loading":{"customClass":"ppl-spinner","message":"<h5>Un instant s’il vous plaît</h5>"}},lang: lang,plugins: {Notify,Loading,LocalStorage,Screen,AppFullscreen,Cookies} })
